(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-components/assets/javascripts/views/parts/rows-display.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-components/assets/javascripts/views/parts/rows-display.js');
"use strict";

const Betslip = svs.components.tipsen.betslipComponents.Betslip;
const ReactIcon = svs.ui.ReactIcon;
const RowsDisplay = _ref => {
  let children = _ref.children,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Rader' : _ref$label,
    ariaLabel = _ref.ariaLabel;
  return React.createElement("div", {
    "aria-label": ariaLabel,
    className: "pg_betslip_rows"
  }, React.createElement("span", {
    className: "pg_betslip_row_title"
  }, label, ' '), React.createElement(ReactIcon, {
    color: "white",
    icon: "rows-three",
    size: "100"
  }), React.createElement("span", {
    className: "pg_betslip_row_value"
  }, children));
};
Betslip.RowsDisplay = RowsDisplay;

 })(window);